import { useMutation, useQueryClient } from 'react-query'
import { postJSON } from '../../../../../common/services/api'
import { showToast } from '../../../../../common/utils'
import { ALERTS_QUERY_KEY, ALERTS_URL } from '../constants'
import type { CreateAlertBody } from '../utils/types'

type UseAlertCreateProps = {
  onSuccess?: () => void
}

type UseAlertCreateReturn = {
  createAlert: (values: CreateAlertBody) => Promise<unknown>
  isCreateLoading: boolean
}

export const useAlertCreate = ({
  onSuccess
}: UseAlertCreateProps = {}): UseAlertCreateReturn => {
  const queryClient = useQueryClient()

  const handleError = (err: any) => {
    showToast({
      title: (err?.message || err?.msg || 'Something went wrong') as string,
      type: 'error'
    })
  }

  const createFunction = async (values: CreateAlertBody) =>
    postJSON({
      url: ALERTS_URL,
      method: 'POST',
      json: values
    })

  const { mutateAsync: createMutation, isLoading: isCreateLoading } =
    useMutation<unknown, unknown, CreateAlertBody, unknown>(
      [ALERTS_QUERY_KEY, 'create'],
      createFunction,
      {
        onSuccess: () => {
          showToast({ title: 'Alert created', type: 'success' })
          queryClient.invalidateQueries([ALERTS_QUERY_KEY])
          onSuccess?.()
        },
        onError: (err) => handleError(err)
      }
    )

  const createAlert = async (values: CreateAlertBody) => {
    try {
      return await createMutation(values)
    } catch (err) {
      return err
    }
  }

  return { createAlert, isCreateLoading }
}
